/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

module.exports = function(done, value){
  return {value: value, done: !!done};
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/_iter-step.js
// module id = 310
// module chunks = 60